export enum HappinessPermission {
  ResolveHappiness = 'HAPPINESS:MESSAGE:RESOLVE',
  ReadMessage = 'HAPPINESS:MESSAGE:READ',
}

export interface HappinessPermissionsData {
  resolveHappiness: boolean;
  readMessage: boolean;
}
